var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.iosStoreLink}},[_c('img',{staticStyle:{"height":"50px"},attrs:{"src":require("@/assets/appleStore.svg"),"alt":_vm.$t('alts.appStore')}})])}
var staticRenderFns = []

export { render, staticRenderFns }